export const superstarsAudioEffects: Map<string, string> = new Map<string, string>([
  ['adventure_superstars_ambiance', 'fx/adventure_superstars_ambiance.mp3'],
  ['adventure_superstars_band_festival', 'fx/adventure_superstars_band_festival.mp3'],
  ['adventure_superstars_contract', 'fx/adventure_superstars_contract.mp3'],
  ['adventure_superstars_demo', 'fx/adventure_superstars_demo.mp3'],
  ['adventure_superstars_kids', 'fx/adventure_superstars_kids.mp3'],
  ['adventure_superstars_paparazzi', 'fx/adventure_superstars_paparazzi.mp3'],
  ['adventure_superstars_paparazzi_gn', 'fx/adventure_superstars_paparazzi_gn.mp3'],

  ['world_superstars_ambiance', 'fx/world_superstars_ambiance.mp3'],
  ['world_superstars_pop-o-matic', 'fx/world_superstars_pop-o-matic.mp3'],
  ['world_superstars_roller_disco', 'fx/world_superstars_roller_disco.mp3'],
  ['world_superstars_spit-pit', 'fx/world_superstars_spit-pit.mp3'],
  ['world_superstars_the_balcony', 'fx/world_superstars_the_balcony.mp3'],
  ['world_superstars_the_cave', 'fx/world_superstars_the_cave.mp3'],
  ['world_superstars_the_garden', 'fx/world_superstars_the_garden.mp3'],
]);